// Shared helpers for pharmacy bill printing.
//
// Copies are driven by generalSettings.PhBillsQty:
//   missing / null / "" / 0 / not a number  -> 1 copy
//   "2" / 2                                 -> 2 copies
// Capped at MAX_COPIES so a bad setting can never flood the printer.

const MAX_COPIES = 10;

export const getBillCopies = (generalSetting) => {
  const raw = generalSetting?.PhBillsQty;
  const count = parseInt(raw, 10);
  if (!Number.isFinite(count) || count < 1) return 1;
  return Math.min(count, MAX_COPIES);
};

// Formats a bill timestamp for the printed header as "DD/MM/YYYY H:MM AM/PM".
// Sources that carry no time component (EntryDate comes back as T00:00:00)
// print as plain "DD/MM/YYYY" instead of a misleading "12:00 AM".
export const formatBillDateTime = (value) => {
  if (!value) return '';
  try {
    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) return String(value);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const datePart = `${day}/${month}/${dateObj.getFullYear()}`;

    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    if (hours === 0 && minutes === 0 && dateObj.getSeconds() === 0) return datePart;

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    return `${datePart} ${hour12}:${String(minutes).padStart(2, '0')} ${ampm}`;
  } catch {
    return String(value ?? '');
  }
};

// Sends the same payload to the printer `copies` times, sequentially so the
// copies do not interleave in the spooler.
export const invokeBillPrint = async (
  ipcRenderer,
  { printerName, json, phBillType, copies = 1 }
) => {
  const channel = phBillType === 'Normal' ? 'print-a5receipt' : 'print-receipt';
  const total = Math.max(1, Number(copies) || 1);

  for (let i = 0; i < total; i++) {
    await ipcRenderer.invoke(channel, { printerName, json });
  }
};
